<router-outlet />
<p-toast key="notification" position="top-right" />
<p-toast key="notificationOneLine" position="top-right" class="oneLine" />
<p-toast key="notificationCustom" position="top-right">
  <ng-template let-message #message>
    <summit-notification [toastData]="message.data" />
  </ng-template>
</p-toast>
<p-toast key="notificationUpdate" position="top-right">
  <ng-template let-message #message>
    <div>
      <summit-notification [toastData]="message.data" />
      <div style="display: flex; gap: 8px; justify-content: flex-end">
        <p-button
          (click)="this.router.navigate(['/updates'])"
          size="small"
          severity="secondary"
          [style]="{ border: '1px solid gray', 'white-space': 'nowrap' }"
          >Changes</p-button
        >
        <p-button (click)="this.updateService.update()" size="small" [style]="{ 'white-space': 'nowrap' }"
          >Reload</p-button
        >
      </div>
    </div>
  </ng-template>
</p-toast>
